// no conflict
var $ = jQuery.noConflict();

//Capture form
document.addEventListener("DOMContentLoaded", function () {
	console.log("Modal script loaded");

	// Close modal on close button click
	document.querySelectorAll(".closeModal").forEach((btn) => {
		btn.addEventListener("click", function () {
			btn.closest(".modal").classList.add("hidden");
			document.body.classList.remove("modal-opened");
		});
	}); 

	// Open modal on trigger click
	document.querySelectorAll("[data-modal-target]").forEach((trigger) => {
		trigger.addEventListener("click", function () {
			const targetId = trigger.getAttribute("data-modal-target");
			const modal = document.getElementById(targetId);
			const postTitle = trigger.getAttribute("data-title");
			const downloadUrl = trigger.getAttribute("data-file");

			if (modal) {
				modal.classList.remove("hidden");
				document.body.classList.add("modal-opened");

				const hiddenInput = modal.querySelector('input[name="item_meta[88]"]');
				const hiddenFile = modal.querySelector('input[name="item_meta[117]"]');

				if (hiddenInput && postTitle) {
					hiddenInput.value = postTitle;
				}

				if (hiddenFile && downloadUrl) {
					hiddenFile.value = downloadUrl;
				}
			}
		});
	});
});
